/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiLibraryScenario,
    InternalApiLibraryScenarioFromJSON,
    InternalApiLibraryScenarioToJSON,
    InternalApiLibraryScenarioPage,
    InternalApiLibraryScenarioPageFromJSON,
    InternalApiLibraryScenarioPageToJSON,
    InternalApiScenario,
    InternalApiScenarioFromJSON,
    InternalApiScenarioToJSON,
    InternalApiScenarioEntityType,
    InternalApiScenarioEntityTypeFromJSON,
    InternalApiScenarioEntityTypeToJSON,
    InternalApiScenarioTypeV2,
    InternalApiScenarioTypeV2FromJSON,
    InternalApiScenarioTypeV2ToJSON,
} from '../models';

export interface FindAllLibraryScenariosRequest {
    page: number;
    size: number;
    types: Array<InternalApiScenarioTypeV2>;
    query?: string;
    entityType?: InternalApiScenarioEntityType;
    categoryNames?: Array<string>;
}

export interface GetLibraryScenarioRequest {
    scenarioHandle: string;
}

export interface ImportLibraryScenarioRequest {
    scenarioHandle: string;
    name: string;
    categoryHandle: string;
    type: InternalApiScenarioTypeV2;
    typologyHandle?: string;
}

/**
 * 
 */
export class ScenarioLibraryInternalApi extends runtime.BaseAPI {

    /**
     * Fetch all library scenarios
     */
    async findAllLibraryScenariosRaw(requestParameters: FindAllLibraryScenariosRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiLibraryScenarioPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllLibraryScenarios.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllLibraryScenarios.');
        }

        if (requestParameters.types === null || requestParameters.types === undefined) {
            throw new runtime.RequiredError('types','Required parameter requestParameters.types was null or undefined when calling findAllLibraryScenarios.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.types) {
            queryParameters['types'] = requestParameters.types;
        }

        if (requestParameters.categoryNames) {
            queryParameters['categoryNames'] = requestParameters.categoryNames;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/scenario-library`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiLibraryScenarioPageFromJSON(jsonValue));
    }

    /**
     * Fetch all library scenarios
     */
    async findAllLibraryScenarios(requestParameters: FindAllLibraryScenariosRequest, initOverrides?: RequestInit): Promise<InternalApiLibraryScenarioPage> {
        const response = await this.findAllLibraryScenariosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get scenario
     */
    async getLibraryScenarioRaw(requestParameters: GetLibraryScenarioRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiLibraryScenario>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling getLibraryScenario.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/scenario-library/{scenarioHandle}`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiLibraryScenarioFromJSON(jsonValue));
    }

    /**
     * Get scenario
     */
    async getLibraryScenario(requestParameters: GetLibraryScenarioRequest, initOverrides?: RequestInit): Promise<InternalApiLibraryScenario> {
        const response = await this.getLibraryScenarioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Import scenario
     */
    async importLibraryScenarioRaw(requestParameters: ImportLibraryScenarioRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenario>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling importLibraryScenario.');
        }

        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling importLibraryScenario.');
        }

        if (requestParameters.categoryHandle === null || requestParameters.categoryHandle === undefined) {
            throw new runtime.RequiredError('categoryHandle','Required parameter requestParameters.categoryHandle was null or undefined when calling importLibraryScenario.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling importLibraryScenario.');
        }

        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.categoryHandle !== undefined) {
            queryParameters['categoryHandle'] = requestParameters.categoryHandle;
        }

        if (requestParameters.typologyHandle !== undefined) {
            queryParameters['typologyHandle'] = requestParameters.typologyHandle;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/scenario-library/{scenarioHandle}`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioFromJSON(jsonValue));
    }

    /**
     * Import scenario
     */
    async importLibraryScenario(requestParameters: ImportLibraryScenarioRequest, initOverrides?: RequestInit): Promise<InternalApiScenario> {
        const response = await this.importLibraryScenarioRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
